import React from 'react';
import { useTranslation } from 'react-i18next';

import type { IGigComplianceRow } from '@/components/agent/gig-compliance/types';

import {
  CardContainer,
  HeaderLabel,
  Row,
  RowLabelCell,
  RowsContainer,
  RowsLabelsContainer,
} from '@/components/agent/gig-compliance/ComplianceTable.styles';
import { COMPLIANCE_CONFIG_TABLE } from '@/constants/contracts';
import { DeviationCell, LateCardSkeleton, LoaderWrapper } from '@/components/common';

interface IProps {
  rowsToDisplay: IGigComplianceRow[];
  isLoading: boolean;
  alwaysShowMobileView?: boolean;
}

const LateCard = ({ rowsToDisplay, isLoading, alwaysShowMobileView }: IProps): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <CardContainer
      width={COMPLIANCE_CONFIG_TABLE.lateIn.width}
      className={alwaysShowMobileView ? 'show-mobile-view' : 'show-default-view'}
    >
      <LoaderWrapper className="h-100" isLoading={isLoading} loader={<LateCardSkeleton />}>
        <HeaderLabel>
          {t`gigCompliance.complianceTable.labelLateIn`}
          <RowsLabelsContainer>
            <RowLabelCell>5-10</RowLabelCell>
            <RowLabelCell>10+</RowLabelCell>
            <RowLabelCell>{t`gigCompliance.complianceTable.labelAvg`}</RowLabelCell>
          </RowsLabelsContainer>
        </HeaderLabel>
        <RowsContainer
          colorOne={COMPLIANCE_CONFIG_TABLE.lateIn.colorOne}
          colorTwo={COMPLIANCE_CONFIG_TABLE.lateIn.colorTwo}
          colorText={COMPLIANCE_CONFIG_TABLE.lateIn.colorText}
        >
          {rowsToDisplay.map(row => (
            <Row key={row.weekSpan}>
              <DeviationCell row={row} rowKey={'lateLogin10Minus'} />
              <DeviationCell row={row} rowKey={'lateLogin10Plus'} />
              <DeviationCell row={row} rowKey={'lateAvg'} displayInMinutes={true} />
            </Row>
          ))}
        </RowsContainer>
      </LoaderWrapper>
    </CardContainer>
  );
};

export { LateCard };
